import { useState } from "react";
import { Mail, Loader2, Wrench } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function TechLogin() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/tech/login", { email }); setSent(true); }
    catch { toast.error("Couldn't send the link — try again or call 310-422-0669"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="tech-login">
      <div className="dg-card rounded-2xl p-8 text-center">
        <Wrench className="w-10 h-10 text-[#FFD600] mx-auto" />
        <div className="dg-eyebrow mt-4">Partner technicians</div>
        <h1 className="mt-2 text-3xl font-extrabold font-display" data-testid="tech-login-title">{sent ? "Check your email" : "Job board sign-in"}</h1>
        {sent ? (
          <p className="text-slate-300 mt-3 text-sm" data-testid="tech-login-sent">If <strong className="text-white">{email}</strong> has a signed partner agreement, a one-tap sign-in link is on its way. It works once and expires in 15 minutes.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <p className="text-slate-400 text-sm">Enter the email on your signed agreement — we'll send a sign-in link. No password needed.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className="dg-input w-full" data-testid="tech-login-email" />
            <button type="submit" disabled={busy} className="dg-btn-primary rounded-full px-6 py-3 w-full inline-flex items-center justify-center gap-2 disabled:opacity-50" data-testid="tech-login-submit">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />} Email me a sign-in link
            </button>
          </form>
        )}
        <p className="text-xs text-slate-500 mt-6">Not a partner yet? Call David at 310-422-0669.</p>
      </div>
    </div>
  );
}
